import { render, staticRenderFns } from "./AddEmailsInvoices.vue?vue&type=template&id=4f071928&"
import script from "./AddEmailsInvoices.vue?vue&type=script&lang=js&"
export * from "./AddEmailsInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports